import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconWarning16 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		children: [/* @__PURE__ */ _jsx("path", { d: "M8.75 10v1.5h-1.5V10zM8.75 9V5.5h-1.5V9z" }), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "m1.265 10.989 5.01-8.546c.772-1.318 2.678-1.318 3.45 0l5.01 8.546c.781 1.333-.18 3.011-1.726 3.011H2.991c-1.546 0-2.507-1.678-1.726-3.011M7.57 3.202l-5.01 8.545a.5.5 0 0 0 .432.753h10.018a.5.5 0 0 0 .432-.753L8.43 3.202a.5.5 0 0 0-.862 0",
			clipRule: "evenodd"
		})]
	})
});
const ForwardRef = forwardRef(SvgIconWarning16);
export default ForwardRef;
